import ToothIcon from '@components/common/ToothIcon/ToothIcon'
import React from 'react'

type TeethProps = { id: number; status: string }

const getToothStatusClass = (status: string): string => {
  switch (status) {
    case 'Planned':
      return ' sp-tooth--planned'
    case 'Treated':
      return ' sp-tooth--treated'
    case 'Missing':
      return ' sp-tooth--missing'
    case 'None':
      return ' sp-tooth--none'
    default:
      return ' sp-tooth--default'
  }
}

type DentalChartProps = {
  upperTeeth: TeethProps[]
  lowerTeeth: TeethProps[]
}
const DentalChart: React.FC<DentalChartProps> = ({
  upperTeeth,
  lowerTeeth,
}): React.ReactElement => {
  const renderTeeth = (teeth: TeethProps[]): React.ReactElement => {
    if (!teeth || teeth.length === 0) return <></>

    return (
      <div className="teeth-grid mb-2">
        {teeth.map((tooth) => (
          <div
            key={tooth.id}
            className={`sp-tooth${getToothStatusClass(tooth.status)} relative w-16 flex items-center justify-center h-100`}
            style={{
              padding: '1px',
              borderRadius: '2.634px 2.634px 0 0',
            }}
          >
            <ToothIcon
              id={tooth.id}
              status={tooth.status}
              width={'auto'}
              height={'auto'}
            />
            <div
              className="tp-tooth-id"
              style={{ borderRadius: '0 0 2.634px 2.634px ' }}
            >
              {tooth.id}
            </div>
          </div>
        ))}
      </div>
    )
  }

  return (
    <div className="sp-treatment-chart-card overflow-x-auto">
      <div className="min-w-fit">
        {renderTeeth(upperTeeth)}
        <div className="h-4"></div>
        {renderTeeth(lowerTeeth)}
      </div>

      <div className="tooth-legend sp-treatment-chart-legend">
        <div className="tooth-legend-tray">
          <div className="tooth-legend-box sp-treatment-legend-planned" />
          <span>Planned</span>
        </div>
        <div className="tooth-legend-tray">
          <div className="tooth-legend-box sp-treatment-legend-treated" />
          <span>Treated</span>
        </div>
        <div className="tooth-legend-tray">
          <div className="tooth-legend-box sp-treatment-legend-missing d-flex align-items-center justify-content-center">
            <i className="missing-tooth mgc_close_fill" />
          </div>
          <span>Missing</span>
        </div>
      </div>
    </div>
  )
}

export default DentalChart
